import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Grid, IconButton } from "@mui/material";
import ScreenDropdown from "app/components/common/ScreenDropdown";
import IncomeLineChart from "./Screen5Graphs/IncomeLineChart";
import IncomeDifferenceChart from "./Screen5Graphs/IncomeDifferenceChart";
import AgeJobCounts from "./Screen5Graphs/AgeJobCounts";
import RaceJobCounts from "./Screen5Graphs/RaceJobCounts";
import GenderJobCounts from "./Screen5Graphs/GenderJobCounts";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import "./Screen5.css";

import {
  fetchIndustryData,
  updateIndustryTypeS3,
  fetchAgeData,
  fetchRaceData,
  fetchGenderData,
} from "../../7screen/redux/screen3/actions";

import {
  fetchOccupationData,
  fetchAverageDataScreen5,
  fetchIncomeDataScreen5,
  fetchIncomeDiffDataScreen5,
  fetchAgeDataScreen5,
  fetchRaceDataScreen5,
  fetchGenderDataScreen5,
  updateOccupationTypeScreen5,
} from "../../7screen/redux/screen5/actions";

import { changeScreenOrientation, updateDataSources } from "../../7screen/redux/ScreensCommon/actions";
import { logActivity } from "../redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";

const Screen5NavTitles = ["Demographics", "Income"];

class Screen5 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subMenuIndex: 0,
      occupationTypeSelected: "Accountants and Auditors",
    };
  }

  handleOccupationTypeChange = (event) => {
    const {
      target: { value },
    } = event;
    this.props.updateOccupationTypeScreen5(value);
    this.state.occupationTypeSelected = value;
    this.props.fetchAverageDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchIncomeDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchIncomeDiffDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchAgeDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchRaceDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchGenderDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );

    logActivity({
      screen : UserActivityConstants.SCREEN5.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : value,
      action : UserActivityConstants.SCREEN5.ACTIONS.SELECT_OCCUPATION
    })

  };

  changeSubMenu = (i) => {
    this.setState({
      subMenuIndex: i,
    });

    logActivity({
      screen : UserActivityConstants.SCREEN5.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : Screen5NavTitles[i],
      action : UserActivityConstants.SCREEN5.ACTIONS.CHANGE_SUB_MENU
    })

  };

  refreshData() {
    this.props.fetchIndustryData();
    this.props.fetchOccupationData();
    this.props.updateOccupationTypeScreen5(this.state.occupationTypeSelected);
    this.props.fetchAverageDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchIncomeDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchIncomeDiffDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchAgeDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchRaceDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
    this.props.fetchGenderDataScreen5(
      this.props.regionSelected,
      this.props.industryTypeSelectedS3,
      this.props.jobTypeSelectedS2,
      this.state.occupationTypeSelected
    );
  }

  componentDidMount() {
    this.refreshData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.regionSelected !== prevProps.regionSelected) {
      this.refreshData();
    }
    if (
      prevProps.jobTypeSelectedS2 !== this.props.jobTypeSelectedS2 ||
      prevProps.industryTypeSelectedS3 !== this.props.industryTypeSelectedS3 ||
      prevProps.occupationTypeSelected !== this.props.occupationTypeSelected
    ) {
      this.props.updateOccupationTypeScreen5(this.state.occupationTypeSelected);
      this.props.fetchAverageDataScreen5(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.occupationTypeSelected
      );
      this.props.fetchIncomeDataScreen5(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.occupationTypeSelected
      );
      this.props.fetchIncomeDiffDataScreen5(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.occupationTypeSelected
      );
      this.props.fetchAgeDataScreen5(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.occupationTypeSelected
      );
      this.props.fetchRaceDataScreen5(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.occupationTypeSelected
      );
      this.props.fetchGenderDataScreen5(
        this.props.regionSelected,
        this.props.industryTypeSelectedS3,
        this.props.jobTypeSelectedS2,
        this.state.occupationTypeSelected
      );
    }
  }

  handleDataSourceToggle = () => {
    this.props.updateDataSources()

    logActivity({
      screen : UserActivityConstants.SCREEN5.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE,
      action : UserActivityConstants.COMMON_ACTIONS.TOGGLE_DATA_SOURCE,
    })
  }

  render() {
    var industryTypes = Object.values(this.props.industryData);
    // var occupationTypes = Object.values(this.props.industryData);
    var occupationTypes = Object.values(this.props.occupationDataScreen5);
    let averageData = this.props.averageDataScreen5;
    let incomeData = Object.values(this.props.incomeDataScreen5);
    let incomeDiffData = Object.values(this.props.incomeDiffDataScreen5);

    var countData = {
      data: Object.values(this.props.ageDataScreen5),
      labels: [
        "Age 65 +",
        "Age 55 to 64",
        "Age 45 to 54",
        "Age 35 to 44",
        "Age 25 to 34",
        "Age 19 to 24",
      ],
    };

    var RING_CHART_DATA = [
      {
        name: "White",
        y: this.props.raceDataScreen5["White"],
        color: "#005898",
      },
      {
        name: "Hispanic",
        y: this.props.raceDataScreen5["Hispanic"],
        color: "#6AA4DC",
      },
      {
        name: "African American",
        y: this.props.raceDataScreen5["African American"],
        color: "#FFB607",
      },
      {
        name: "Asian",
        y: this.props.raceDataScreen5["Asian"],
        color: "#FB6A59",
      },
      {
        name: "American Indian",
        y: this.props.raceDataScreen5["American Indian"],
        color: "#DE3E40",
      },
      {
        name: "Two or More Races",
        y: this.props.raceDataScreen5["Two or More Races"],
        color: "#70898E",
      },
    ];

    var PIE_CHART_DATA = [
      {
        name: "Male",
        y: this.props.genderDataScreen5["Male"],
        color: "#6AA4DC",
      },
      {
        name: "Female",
        y: this.props.genderDataScreen5["Female"],
        color: "#FB6A59",
      },
    ];
    return (
      <div className="screen-wrapper" style={{ zIndex: 100 }}>
        <header className="screen-header">
          <IconButton
              id="data-sources-icon"
              style={{
                color: "white",
                marginLeft: 20,
                marginRight: -60,
                marginTop: -155,
                position: 'relative', // This is required for z-index to work
                zIndex: 1000,
              }}
              onClick={this.handleDataSourceToggle}
            >
              <LibraryBooksIcon className="swap-icon" />
            </IconButton>
          <div className="title">Occupation Detail</div>
          <div className="screen-menu">
            {Screen5NavTitles.map((title, i) => (
              <div
                key={i}
                className={`screen-menu-item ${
                  this.state.subMenuIndex === i ? "selected" : ""
                }`}
                onClick={() => this.changeSubMenu(i)}
              >
                {title}
                <br />
              </div>
            ))}
          </div>
        </header>
        <Grid
          container
          className="screen-content-wrapper screen-content-wrapper-5"
        >
          <Grid
            container
            className="screen-content-grid-5"
            style={{ height: "915px" }}
          >
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div
                style={{ backgroundColor: "#005898" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Demand</span>{" "}
                <b>
                  {averageData.jobs_change_sum
                    ? averageData.jobs_change_sum.toLocaleString("en-US")
                    : "NA"}{" "}
                </b>
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div
                style={{ backgroundColor: "#6AA4DC" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Attrition</span>{" "}
                <b>
                  {averageData.average_attrition
                    ? averageData.average_attrition
                    : "NA"}
                </b>
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div
                style={{ backgroundColor: "#FFB607" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Leadership Score</span>{" "}
                <b>
                  {averageData.average_leadership_equity
                    ? averageData.average_leadership_equity
                    : "NA"}
                </b>
              </div>
            </Grid>
            <Grid item md={2.4} className="aggregated-metric-wrapper">
              <div
                style={{ backgroundColor: "#FB6A59" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Automation Risk</span>{" "}
                <b>{averageData.average_ai ? averageData.average_ai : "NA"}</b>
              </div>
            </Grid>
            <Grid
              item
              md={2.4}
              className="aggregated-metric-wrapper"
              style={{ paddingRight: 0 }}
            >
              <div
                style={{ backgroundColor: "#DE3E40" }}
                className="rect-shape"
              >
                <span style={{ display: "block" }}>Unemployment</span>{" "}
                <b>
                  {averageData.average_unemployment
                    ? averageData.average_unemployment
                    : "NA"}
                </b>
              </div>
            </Grid>
            {this.state.subMenuIndex === 0 ? (
              <Grid item md={5}>
                <AgeJobCounts
                  occupationTypes={occupationTypes}
                  occupationTypeSelected={this.state.occupationTypeSelected}
                  handleOccupationTypeChange={this.handleOccupationTypeChange}
                  countData={countData}
                />
              </Grid>
            ) : (
              <></>
            )}
            {this.state.subMenuIndex === 0 ? (
              <Grid item md={3.5}>
                {RING_CHART_DATA.length != 0 && hasData(RING_CHART_DATA) ? (
                  <RaceJobCounts raceData={RING_CHART_DATA} />
                ) : (
                  <div style={{ textAlign: "center", paddingTop: "400px" }}>
                    {" "}
                    No data available{" "}
                  </div>
                )}
              </Grid>
            ) : (
              <></>
            )}
            {this.state.subMenuIndex === 0 ? (
              <Grid item md={3.5}>
                {PIE_CHART_DATA.length != 0 && hasData(PIE_CHART_DATA) ? (
                  <GenderJobCounts
                    industryType={this.props.industryTypeSelectedS3}
                    pieData={PIE_CHART_DATA}
                  />
                ) : (
                  <div style={{ textAlign: "center", paddingTop: "400px" }}>
                    {" "}
                    No data available{" "}
                  </div>
                )}
              </Grid>
            ) : (
              <></>
            )}
            {this.state.subMenuIndex === 1 ? (
              <Grid item md={5.71}>
                <IncomeLineChart
                  occupationTypes={occupationTypes}
                  occupationTypeSelected={this.state.occupationTypeSelected}
                  handleOccupationTypeChange={this.handleOccupationTypeChange}
                  incomeData={incomeData}
                />
              </Grid>
            ) : (
              <></>
            )}
            {this.state.subMenuIndex === 1 ? (
              <Grid item md={6.29}>
                <div className="legend-for-income-diff-graph">
                  <table>
                    <tr>
                      <td
                        className="square-shape"
                        style={{ backgroundColor: "#DE3E40" }}
                      ></td>
                      <td className="legend-label">American Indian</td>
                      <td
                        className="square-shape"
                        style={{ backgroundColor: "#6AA4DC" }}
                      ></td>
                      <td className="legend-label">Hispanic</td>
                      <td
                        className="square-shape"
                        style={{ backgroundColor: "#FB6A59" }}
                      ></td>
                      <td className="legend-label">
                        Asian and Pacific Islander
                      </td>
                    </tr>
                    <tr>
                      <td
                        className="square-shape"
                        style={{ backgroundColor: "#FFB607" }}
                      ></td>
                      <td className="legend-label">African American</td>
                      <td
                        className="square-shape"
                        style={{ backgroundColor: "#70898E" }}
                      ></td>
                      <td className="legend-label">Two or More Races</td>
                      <td
                        className="square-shape"
                        style={{ backgroundColor: "#005898" }}
                      ></td>
                      <td className="legend-label">White</td>
                    </tr>
                  </table>
                </div>
                Income Difference by Race/Ethnicity
                {incomeDiffData.length != 0 ? (
                  <IncomeDifferenceChart incomeDiffData={incomeDiffData} />
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      justifyContent: "center",
                      height: "900px",
                      paddingTop: "400px",
                    }}
                  >
                    {" "}
                    No data available{" "}
                  </div>
                )}
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

function hasData(chartData) {
  let hasNodata = true;
  chartData.forEach((elem) => {
    if (elem && elem.y && elem.y.length != 0) {
      hasNodata = false;
    }
  });
  return !hasNodata;
}

function mapStateToProps(state) {
  return {
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
    regionSelected: state.Screen1Reducer.regionSelected,
    jobTypeSelectedS2: state.Screen2Reducer.jobTypeSelectedS2,
    industryTypeSelectedS3: state.Screen3Reducer.industryTypeSelectedS3,
    industryData: { ...state.Screen3Reducer.industryData },
    averageDataScreen5: { ...state.Screen5Reducer.averageDataScreen5 },
    incomeDataScreen5: { ...state.Screen5Reducer.incomeDataScreen5 },
    incomeDiffDataScreen5: { ...state.Screen5Reducer.incomeDiffDataScreen5 },
    ageDataScreen5: { ...state.Screen5Reducer.ageDataScreen5 },
    raceDataScreen5: { ...state.Screen5Reducer.raceDataScreen5 },
    genderDataScreen5: { ...state.Screen5Reducer.genderDataScreen5 },
    occupationDataScreen5: { ...state.Screen5Reducer.occupationDataScreen5 },
    ageData: { ...state.Screen3Reducer.ageData },
    raceData: { ...state.Screen3Reducer.raceData },
    genderData: { ...state.Screen3Reducer.genderData },
    displayDataSources: state.ScreensCommonReducer.displayDataSources,
    occupationType: state.Screen5Reducer.occupationTypeSelected,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchOccupationData,
      fetchIndustryData,
      updateIndustryTypeS3,
      changeScreenOrientation,
      fetchAverageDataScreen5,
      fetchIncomeDataScreen5,
      fetchIncomeDiffDataScreen5,
      fetchAgeDataScreen5,
      fetchRaceDataScreen5,
      fetchGenderDataScreen5,
      updateOccupationTypeScreen5,
      updateDataSources,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Screen5);
